/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-16 22:11:48
 *
 *******************************************************/
/// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, getFormValues, change } from 'redux-form';
import { FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';

import ValuesList from 'src/components/views/filter-tree/item/option-modal/general-tab/percent-sale/values-list';

type Props = WithI18nProps;

class PercentSale extends Component<Props, State> {
  render() {
    const { percentSaleList, updatePercentSaleListItem, i18n } = this.props;

    return (
      <FormLayout>
        <Field
          name="percentSaleExcludePriceFromValue"
          component={RenderCheckbox}
          label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_PercentSale_Field_Label')}
          tooltip={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_PercentSale_Field_Tooltip')}
        />
        <FieldArray
          name="percentSaleList"
          component={ValuesList}
          percentSaleList={percentSaleList}
          updatePercentSaleListItem={updatePercentSaleListItem}
        />
      </FormLayout>
    );
  }
}

const mapStateToProps = (state, props) => {
  const formFilterOptionValues = getFormValues('OptionModalForm')(state);

  return {
    percentSaleList: _.get(formFilterOptionValues, 'percentSaleList', '')
  };
};

const mapDispatchToProps = dispatch => ({
  updatePercentSaleListItem: (index, data) =>
    dispatch(change(`OptionModalForm`, `percentSaleList[${index}]`, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(PercentSale));
